var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("StepTitle", { attrs: { "step-num": "3", title: "设置签名" } }),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            size: "small",
            rules: _vm.rules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "姓名", prop: "name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.name,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "name", $$v)
                  },
                  expression: "ruleForm.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "特殊字体" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.font,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "font", $$v)
                    },
                    expression: "ruleForm.font"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "hwxk" } }, [
                    _vm._v("华文行楷")
                  ]),
                  _c("el-radio", { attrs: { label: "mbxs" } }, [
                    _vm._v("毛笔行书")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "预览" } }, [
            _c(
              "p",
              {
                staticClass: "preview",
                style: { "font-family": _vm.ruleForm.font }
              },
              [_vm._v(_vm._s(_vm.ruleForm.name))]
            )
          ]),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v("立即创建")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("canvas", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        ref: "canvas",
        staticClass: "myCanvas",
        attrs: { width: "473", height: "270" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }